import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';

export const PADDING_X_BREAKPOINT = 'sm';
export const PADDING_X_UNITS = 3;
export const PADDING_X_UNITS_SM = 2;

const Root = styled('div', { shouldForwardProp: prop => prop !== 'topLevel' })(
  ({ theme: { breakpoints, constants, spacing } }) => ({
    maxWidth: constants.WRAPPER_MAX_WIDTH_LG + parseInt(spacing(PADDING_X_UNITS * 2)),
    width: '100%',
    paddingLeft: spacing(PADDING_X_UNITS),
    paddingRight: spacing(PADDING_X_UNITS),
    marginLeft: 'auto',
    marginRight: 'auto',
    [breakpoints.down(PADDING_X_BREAKPOINT)]: {
      paddingLeft: spacing(PADDING_X_UNITS_SM),
      paddingRight: spacing(PADDING_X_UNITS_SM),
    },
    variants: [
      {
        props: ({ topLevel }) => topLevel,
        style: { paddingTop: spacing(constants.APPBAR_OFFSET_UNITS + 2) },
      },
    ],
  }),
);

export default forwardRef(function Container(props, ref) {
  const { children, className, topLevel } = props;

  return (
    <Root className={className} ref={ref} topLevel={topLevel}>
      {children}
    </Root>
  );
});
